import React from 'react';
import { useSelector } from 'react-redux';
import BreadCrumbs from '../../../../components/common/bread_crumbs';
import * as routes from '../../../../constants/routes';
import './index.scss';

const Header = ({ title, additionalBreadcrumb = undefined }) => {
  const translations = useSelector((store) => store.config.Translations);

  const rootBreadcrumb = {
    text: 'דף הבית',
    route: routes.home,
  };

  const breadcrumbsList = [{
    text: translations['forum_base_route_breadcrumb'],
    route: routes.forum,
  }];

  if (additionalBreadcrumb) {
    breadcrumbsList.push(additionalBreadcrumb);
  }

  return (
    <header className="forum-header">
      <div className="header-content-container">
        <h1 className="header-title-element">
          {title}
        </h1>
      </div>

      <BreadCrumbs
        root={rootBreadcrumb}
        crumbs={breadcrumbsList}
        className="header-breadcrumbs"
      />
    </header>
  );
};

export default Header;
